import React from "react";
import { MenuItem } from "./menu-item";

export const Menu = ({ items }) => {
    const classes = "menu rc-slim-scroll";

    return (
        <ul data-testid="menu" className={classes}>
            {items.map((item) => (
                <MenuItem item={item} key={item.title} />
            ))}
        </ul>
    );
};
